import "./App.css"
import {

  BrowserRouter,

  Routes,

  Route,

  Navigate

} from "react-router-dom";

import Login from "./pages/Login";

import Dashboard from "./pages/Dashboard";

import DomainList from "./pages/DomainList";

import DomainDetails from "./pages/DomainDetails";

import DomainMonitors from "./pages/DomainMonitors";

import ActivityLog from "./pages/ActivityLog";

import ServerActivityLog from "./pages/ServerActivityLog";

import Users from "./pages/Users";

import UserForm from "./pages/UserForm";

import Category from "./pages/Category";

import Invoices from "./pages/Invoices";

import Locations from "./pages/Locations";
import InvoiceForm from "./pages/InvoiceForm";

import ExpiryAlerts from "./pages/ExpiryAlerts";

import Sessions from "./pages/Sessions";

import EditDomain from "./pages/EditDomain";

import AddServer from "./pages/AddServer";
import EditServer from "./pages/EditServer";

import ServerList from "./pages/ServerList";

import Trash from "./pages/Trash";

import Clients from "./pages/Clients";
import AddClient from "./pages/AddClient";
import EditClient from "./pages/EditClient";

import BankAccounts from "./pages/BankAccounts";

import Settings from "./pages/Settings";

import AttendanceToday from "./pages/attendance/AttendanceToday";
import DailyReport from "./pages/attendance/DailyReport";
import MonthlyRegister from "./pages/attendance/MonthlyRegister";
import EmployeeAttendance from "./pages/attendance/EmployeeAttendance";

import ProtectedRoute from "./components/ProtectedRoute";
import ScrollToTop from "./components/ScrollToTop";

function App() {

  return (

    <BrowserRouter>
      <ScrollToTop />

      <Routes>

        <Route
          path="/"
          element={<Login />}
        />

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>

              <Dashboard />

            </ProtectedRoute>
          }
        />

        <Route
          path="/domains"
          element={
            <ProtectedRoute module="domains">

              <DomainList />

            </ProtectedRoute>
          }
        />

        <Route
          path="/domains/:id/edit"
          element={
            <ProtectedRoute module="domains" action="edit">

              <EditDomain />

            </ProtectedRoute>
          }
        />

        <Route
          path="/domains/:id"
          element={
            <ProtectedRoute module="domains">

              <DomainDetails />

            </ProtectedRoute>
          }
        />

        <Route
          path="/domain-monitors"
          element={
            <ProtectedRoute module="monitors">

              <DomainMonitors />

            </ProtectedRoute>
          }
        />

        <Route
          path="/activity-log"
          element={
            <ProtectedRoute module="logs">

              <ActivityLog />

            </ProtectedRoute>
          }
        />

        <Route
          path="/server-activity-log"
          element={
            <ProtectedRoute module="logs">

              <ServerActivityLog />

            </ProtectedRoute>
          }
        />

        <Route
          path="/users"
          element={
            <ProtectedRoute adminOnly>

              <Users />

            </ProtectedRoute>
          }
        />

        <Route
          path="/users/new"
          element={
            <ProtectedRoute adminOnly>

              <UserForm />

            </ProtectedRoute>
          }
        />

        <Route
          path="/users/:id/edit"
          element={
            <ProtectedRoute adminOnly>

              <UserForm />

            </ProtectedRoute>
          }
        />

        <Route
          path="/category"
          element={
            <ProtectedRoute module="categories">

              <Category />

            </ProtectedRoute>
          }
        />

        <Route
          path="/add-invoice"
          element={
            <ProtectedRoute module="invoices" action="add">

              <InvoiceForm />

            </ProtectedRoute>
          }
        />

        <Route
          path="/invoices/:id/edit"
          element={
            <ProtectedRoute module="invoices" action="edit">

              <InvoiceForm />

            </ProtectedRoute>
          }
        />

        <Route
          path="/invoices"
          element={
            <ProtectedRoute module="invoices">

              <Invoices />

            </ProtectedRoute>
          }
        />

        <Route
          path="/locations"
          element={
            <ProtectedRoute module="locations">

              <Locations />

            </ProtectedRoute>
          }
        />

        <Route
          path="/expiry-alerts"
          element={
            <ProtectedRoute module="alerts">

              <ExpiryAlerts />

            </ProtectedRoute>
          }
        />

        <Route
          path="/sessions"
          element={
            <ProtectedRoute module="sessions">

              <Sessions />

            </ProtectedRoute>
          }
        />

        <Route
          path="/add-server"
          element={
            <ProtectedRoute module="servers" action="add">

              <AddServer />

            </ProtectedRoute>
          }
        />

        <Route
          path="/servers/:id/edit"
          element={
            <ProtectedRoute module="servers" action="edit">

              <EditServer />

            </ProtectedRoute>
          }
        />

        <Route
          path="/servers"
          element={
            <ProtectedRoute module="servers">

              <ServerList />

            </ProtectedRoute>
          }
        />

        <Route
          path="/trash"
          element={
            <ProtectedRoute>

              <Trash />

            </ProtectedRoute>
          }
        />

        <Route
          path="/add-client"
          element={
            <ProtectedRoute module="clients" action="add">

              <AddClient />

            </ProtectedRoute>
          }
        />

        <Route
          path="/clients/:id/edit"
          element={
            <ProtectedRoute module="clients" action="edit">

              <EditClient />

            </ProtectedRoute>
          }
        />

        <Route
          path="/clients"
          element={
            <ProtectedRoute module="clients">

              <Clients />

            </ProtectedRoute>
          }
        />

        <Route
          path="/bank-accounts"
          element={
            <ProtectedRoute module="bankAccounts">

              <BankAccounts />

            </ProtectedRoute>
          }
        />

        <Route
          path="/settings"
          element={
            <ProtectedRoute>

              <Settings />

            </ProtectedRoute>
          }
        />

        {/* --- Attendance (biometric / SmartOffice) --- */}
        <Route
          path="/attendance"
          element={
            <ProtectedRoute module="attendance">
              <AttendanceToday />
            </ProtectedRoute>
          }
        />

        <Route
          path="/attendance/daily"
          element={
            <ProtectedRoute module="attendance">
              <DailyReport />
            </ProtectedRoute>
          }
        />

        <Route
          path="/attendance/monthly"
          element={
            <ProtectedRoute module="attendance">
              <MonthlyRegister />
            </ProtectedRoute>
          }
        />

        <Route
          path="/attendance/employee/:code"
          element={
            <ProtectedRoute module="attendance">
              <EmployeeAttendance />
            </ProtectedRoute>
          }
        />

        {/* Unknown URL → send to login (which redirects on to the dashboard
            if already authenticated) */}
        <Route path="*" element={<Navigate to="/" replace />} />

      </Routes>

    </BrowserRouter>

  );
}

export default App;